import { useEffect } from "react";
import { useState } from "react";
import { Col, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaHandPointRight } from "react-icons/fa";
import { connect } from "react-redux";
import Toggle from "react-toggle";
import { setCartMembership } from "../../../redux/actions/cartAction";
import {
  setLoginPopup,
  toggleLoginForm,
} from "../../../redux/actions/globalAction";
import moment from "moment";
import { isMobile } from "react-device-detect";

function MembershipBox({
  apiData,
  cart,
  profile,
  loginData,
  setCartMembership,
  setLoginPopup,
  toggleLoginForm,
}) {
  // const [levelUp, setLevelUp] = useState(false);

  const changeMembership = (status) => {
    setCartMembership(status);
  };

  const tooltip = (
    <Tooltip
      className="cs-tooltip"
      style={{
        fontSize: "12px",
        boxShadow: "none",
        background: "transparent",
        textAlign: "left",
      }}
    >
      • Free Pickup Drop On All Services
      <br />
      • Earn Double OB CashPoints
      <br />• Get Exclusive Offers
    </Tooltip>
  );

  useEffect(() => {
    if (loginData.userAuth?.Membership) {
      setCartMembership(false);
    }
  }, [loginData.userAuth]);

  return loginData.userAuth?.Membership ? (
    !isMobile ? (
      <div className="level-up-box lvcae-1-mb">
        <div className="d-flex  align-items-center p-1 pt-1">
          <div className="flx-box">
            <div className="bdg-txt-block lvlup-logo">
              <img
                src="/assets/images/level-up.png"
                className=" mobile-sm"
                alt="level-up"
              />

              <div className="txt-bdg blacktxt-bdg">
                <p className="">Annual Subscription</p>
                <span className="blc-txt">Status: Active</span>
              </div>
            </div>

            <p className="valid-txt blc-txt">
              <span className="blc-txt"> Valid Till </span>
              {moment(new Date(loginData.userAuth?.Membership?.EndFrom)).format(
                "DD/MM/YYYY"
              )}
            </p>
          </div>
          <div></div>
        </div>
      </div>
    ) : (
      <div className="level-up-box lvcae-1 ">
        <div className="d-flex  align-items-center p-1 pt-1">
          <div className="flx-box">
            <div className="bdg-txt-block lvlup-logo mb-lv-logo-space ">
              <img
                style={{ float: "left", marginTop: "2px", marginBottom: "-3px" }}
                src="/assets/images/level-up.png"
                className="mr-1 mobile-sm"
                alt="level-up"
                width={110}
              />
              <div className="txt-bdg blacktxt-bdg">
                <p className="blc-txt">Annual Subscription</p>
                <span className="blc-txt">Status: Active</span>
              </div>
            </div>

            <p className="valid-txt blc-txt">
              <span className="blc-txt"> Valid Till </span>
              {moment(new Date(loginData.userAuth?.Membership?.EndFrom)).format(
                "DD/MM/YYYY"
              )}
            </p>
          </div>
          <div></div>
        </div>
      </div>
    )
  ) : (
    <>
      <div class="island-offer-control">
				<div class="island-offer-tp">
					<div class="island-offertp-lf">
						<small>
							<img src="/assets/images/level-up.png"/>
						</small>
						<label>
							<h3>PREMIUM ANNUAL SUBSCRIPTION</h3>
							<strong>For Just <u>AED {apiData.levelupMembership?.Cost}</u></strong>
              <div className="show-section-mobile">
              <p
                data-bs-toggle="tooltip"
                title="Tooltip on top"
                data-bs-placement="top"
                className="m-0 mb-1 text-dark "
              >
                <FaHandPointRight className="mr-1" />
                <OverlayTrigger style={{ background: "red" }} overlay={tooltip}>
                  <u>Benefits</u>
                </OverlayTrigger>
              </p>
              </div>
						</label>
         

           
					</div>
          <div className="island-offertp-rght">
              
              {loginData.userAuth?.Membership == null && (
                <p className="m-0 mb-1">
                  {cart.addMembership ? (
                    <a
                      role="button"
                      className="btn btn-success bg-yellow mr-2"
                      style={{
                        fontSize: "15px",
                        padding: "4px 21px",
                        fontWeight: "500",
                        borderRadius: 9,
                        border: "none",
                      }}
                      onClick={(e) => changeMembership(false)}
                    >
                      REMOVE
                    </a>
                  ) : (
                    <a
                      role="button"
                      className="btn  mr-2 add-sub-list"
                    
                      onClick={(e) => changeMembership(true)}
                    >
                      ADD
                    </a>
                  )}
                </p>
              )}
              <p>
                {!loginData.userAuth && (
                  <a
                    // role="button"
                    // className="btn btn-success bg-yellow mr-2"
                    className="mr-2 lgbtn-sub"
                   
                    onClick={() => {
                      toggleLoginForm(true);
                      setLoginPopup(true);
                    }}
                  >
                    <u>Login</u>
                  </a>
                )}
              </p>
            </div>
  

				</div>
			<div class="show-section-web island-offer-bt">
					<ul>
						<li>•  Free Pickup Drop On All Services </li>
						<li>•  Earn Double OB CashPoints</li>
						<li>•  Get Exclusive Offers</li>
					</ul> 
			
        

            </div> 

			</div>

    </>
  );
}

// setCartMembership

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
    loginData: state.loginData,
    profile: state.profile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCartMembership: (membership) => {
      dispatch(setCartMembership(membership));
    },
    setLoginPopup: (stage) => {
      dispatch(setLoginPopup(stage));
    },
    toggleLoginForm: (stage) => {
      dispatch(toggleLoginForm(stage));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MembershipBox);
